<template>
    <tr class="transition dark:text-white"
        :class="[bg, 'hover:' + hoverBg, 'dark:' + darkBg, 'dark:hover:' + darkHoverBg, dividerClasses]">
        <slot/>
    </tr>
</template>

<script>
export default {
    name: 'TableRow',

    props: {
        bg: {
            type: String,
            default: 'bg-white',
        },
        hoverBg: {
            type: String,
            default: 'bg-gray-50',
        },
        darkBg: {
            type: String,
            default: 'bg-gray-700',
        },
        darkHoverBg: {
            type: String,
            default: 'bg-gray-800',
        },

        hasDivider: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        dividerClasses() {
            return this.hasDivider
                ? ['divide-x', 'divide-gray-200', 'dark:divide-gray-600']
                : [];
        },
    },
};
</script>
